import styled from "styled-components";
import { HeaderContainer } from "components/Header/styles";

export const StyledHeader = styled.div`
  ${HeaderContainer} {
    padding: 2rem 3rem;
    border-bottom: 1px solid #3d3d3d;
    margin-bottom: 0rem;
  }
`;

export const Body = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: calc(100% - 101px);
  overflow: hidden;
`;

export const FilterColumn = styled.div`
  overflow-y: scroll;
`;

export const FilterColumnBody = styled.div`
  padding: 2rem;
  background: var(--black-100);
`;

export const TabHeaderContainer = styled.div`
  border-bottom: 1px solid #3d3d3d;
  padding: 0rem 2rem;
  margin-top: 0.3rem;
`;

export const MarkerListContainer = styled.div`
  height: fit-content;
  padding: 2rem;
`;

export const MapColumn = styled.div`
  height: 100%;
  z-index: 99;
`;
